import React, { useState } from "react"
import { SurveyData } from "interfaces/dataInterfaces"
import {
  useSaveSurveyRPMEFileMutation,
  useSaveSurveyRPMEMutation,
  useValidateSurveyRPMEMinRequiredFieldsQuery,
  useValidateSurveyRPMEQuery,
} from "../../services/rpme/survey"
import { useGetXlsFormQuery } from "../../services/rpme/xlsFormSchemas"
import AddSurvey from "./AddSurvey"
import { ISurveyData } from "./SurveyRPME"

const initialState = {
  addAdmCode: null,
  xlsFormId: null,
}

function SurveyRPME() {
  const [data, setData] = useState<Partial<ISurveyData>>(initialState)
  const { addAdmCode, xlsFormId } = data

  const [saveCSVFile, { data: csvFile, isLoading: isFileSaving }] = useSaveSurveyRPMEFileMutation()
  const { data: validateSurveyRes, isFetching: isValidateFetching } = useValidateSurveyRPMEQuery(
    { adm0Code: addAdmCode ?? 0, xlsFormID: xlsFormId ?? 0, fileName: csvFile?.fileName ?? "" },
    { skip: !addAdmCode || !xlsFormId || !csvFile },
  )
  const { data: validateSurveyMin, isFetching: isValidateMinFetching } = useValidateSurveyRPMEMinRequiredFieldsQuery(
    { adm0Code: addAdmCode ?? 0, xlsFormID: xlsFormId ?? 0, fileName: csvFile?.fileName ?? "" },
    { skip: !addAdmCode || !xlsFormId || !csvFile || isValidateFetching },
  )
  const [saveSurvey, { isLoading: isSaving, isSuccess, data: surveySaveData }] = useSaveSurveyRPMEMutation()

  const { data: xlsForms } = useGetXlsFormQuery(
    { take: 50, skip: 0, adm0Code: addAdmCode ?? 0, search: "" },
    { skip: !addAdmCode },
  )

  const onSaveCSVFile = (dataSave: FormData) => {
    saveCSVFile(dataSave)
  }

  const onSaveSurvey = async (dataSave: SurveyData) => {
    return saveSurvey({ ...dataSave, surveyOriginalFilename: csvFile?.fileName ?? "" }).unwrap()
  }

  return (
    <AddSurvey
      surveyTypeId={2}
      data={data}
      setData={setData}
      isFileSaving={isFileSaving}
      isValidateFetching={isValidateFetching}
      validateSurveyRes={validateSurveyRes}
      isValidateMinFetching={isValidateMinFetching}
      validateSurveyMin={validateSurveyMin}
      saveCSVFile={onSaveCSVFile}
      saveSurvey={onSaveSurvey}
      isSaving={isSaving}
      isSuccess={isSuccess}
      surveyData={surveySaveData}
      xlsForms={xlsForms}
    />
  )
}

export default SurveyRPME
